export const PRIVACY_TERMS_SITES = [
  {
    name: 'Drive',
    displayUrl: 'https://drive.co.uk',
    url: 'https://drive.co.uk',
  },
  {
    name: 'RAC Cars',
    url: 'https://cars.rac.co.uk',
  },
];
